import { render, staticRenderFns } from "./ReqDashboard.vue?vue&type=template&id=2569d268"
import script from "./ReqDashboard.vue?vue&type=script&lang=js"
export * from "./ReqDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports